import { fireTrackEvent } from './tracking';

let chatAnalyticsInitialized = false;
export function initChatAnalytics(retryCount = 0) {
    if (chatAnalyticsInitialized) return;
    if (
        (window as any).lpTag !== undefined &&
        (window as any).lpTag.events !== undefined &&
        (window as any)._waEvents !== undefined
    ) {
        chatAnalyticsInitialized = true;
        const eventNames = [
            'state',
            'SHOW',
            'cobrowseInvited',
            'cobrowseOffered',
            'cobrowseAccepted',
            'sessionStarted',
            'cobrowseDeclined',
            'cobrowseTimeout',
            'sessionEnd',
            'cobrowseEnded',
        ];
        eventNames.forEach((x: string) => {
            window.lpTag.events.bind({
                eventName: x,
                func: (eventObj: any) => {
                    console.log('eventNames', x, eventObj);
                    if (!eventObj || typeof eventObj === 'string') {
                        console.log('not tracked', eventObj);
                        return;
                    }
                    if (x === 'state') {
                        console.log('object', eventObj);
                        const events = [
                            'SHOW',
                            'resume',
                            'initialised',
                            'preChat',
                            'postChat',
                            'chatting',
                            'interactive',
                            'ended',
                            'applicationEnded',
                            'offline',
                        ];
                        let theState: string = eventObj.state;

                        if (events.includes(theState)) {
                            if (theState === 'SHOW') {
                                theState = 'appears';
                            } else if (theState === 'initialised') {
                                theState = 'start';
                            } else if (theState === 'applicationEnded') {
                                theState = 'appEnded';
                            }
                            console.log('found', theState);
                            fireTrackEvent({
                                page: { action: `Chat:${theState}` },
                                eventList: `chat_${theState}`,
                            });
                        } else {
                            console.log('not found', theState);
                        }
                    } else {
                        console.log('track nonState', x);

                        let theState: string = x;
                        if (theState === 'SHOW') {
                            theState = 'appears';
                        } else if (theState === 'sessionStarted') {
                            theState = 'cobrowseStarted';
                        } else if (theState === 'sessionEnd') {
                            theState = 'cobrowseEnded';
                        }
                        fireTrackEvent({
                            page: { action: `Chat:${theState}` },
                            eventList: `chat:${theState}`,
                        });
                    }
                },
                triggerOnce: false,
            });
        });
    } else {
        //console.log('>>>>>>>retry: ', retryCount);
        if (retryCount < 15) {
            setTimeout(() => {
                initChatAnalytics(retryCount ? ++retryCount : 1);
            }, 300);
        }
    }
}
